module.exports = __webpack_public_path__ + "img/stephen-a-douglass.1cf62c38.png";